module.exports = __webpack_public_path__ + "img/volume_off_red.ed0bfc23.svg";